var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4002 17.84H10.8902C9.25016 17.84 7.92016 16.46 7.92016 14.76C7.92016 14.35 8.26016 14.01 8.67016 14.01C9.08016 14.01 9.42016 14.35 9.42016 14.76C9.42016 15.63 10.0802 16.34 10.8902 16.34H13.4002C14.0502 16.34 14.5902 15.76 14.5902 15.06C14.5902 14.19 14.2802 14.02 13.7702 13.84L9.74016 12.42C8.96016 12.15 7.91016 11.57 7.91016 9.78C7.91016 8.24 9.12016 7 10.6002 7H13.1102C14.7502 7 16.0802 8.38 16.0802 10.08C16.0802 10.49 15.7402 10.83 15.3302 10.83C14.9202 10.83 14.5802 10.49 14.5802 10.08C14.5802 9.21 13.9202 8.5 13.1102 8.5H10.6002C9.95016 8.5 9.41016 9.08 9.41016 9.78C9.41016 10.65 9.72016 10.82 10.2302 11L14.2602 12.42C15.0402 12.69 16.0902 13.27 16.0902 15.06C16.0802 16.59 14.8802 17.84 13.4002 17.84Z",
    fill: "#B0BECF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.1719C11.59 19.1719 11.25 18.8319 11.25 18.4219V6.42188C11.25 6.01188 11.59 5.67188 12 5.67188C12.41 5.67188 12.75 6.01188 12.75 6.42188V18.4219C12.75 18.8319 12.41 19.1719 12 19.1719Z",
    fill: "#B0BECF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.1719C6.07 23.1719 1.25 18.3519 1.25 12.4219C1.25 6.49188 6.07 1.67188 12 1.67188C17.93 1.67188 22.75 6.49188 22.75 12.4219C22.75 18.3519 17.93 23.1719 12 23.1719ZM12 3.17188C6.9 3.17188 2.75 7.32188 2.75 12.4219C2.75 17.5219 6.9 21.6719 12 21.6719C17.1 21.6719 21.25 17.5219 21.25 12.4219C21.25 7.32188 17.1 3.17188 12 3.17188Z",
    fill: "#B0BECF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCircle);
export default __webpack_public_path__ + "static/media/dollar-circle.242b80162056fb9046ac649c321cd852.svg";
export { ForwardRef as ReactComponent };